const FeedbackData=[
  {
    id:1,
    rating:10,
    text:'I really appreciated how you used check-ins to keep me up to date on your project this week. It helped me coordinate with our stakeholders'
  },
  {
    id:2,
    rating:8,
    text:'You really went above and beyond to solve this complex issue in a timely manner'
  },
  {
    id:3,
    rating:9,
    text:'Your willingness to look outside of yourself and make those around you better is one of the most valuable contributions you’re making. Thank you'
  }
]

export default FeedbackData